import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err)
}

const routes = [
  {
    path: '/',
    redirect: '/loginform'
  },
  {
    path: '/login',
   redirect: '/loginform'
  },
  {
    path: '/loginform',
    component: () => import('@/views/login/LoginForm')
  },
  {
    path: '/success',
    component: () => import('@/views/login/success')
  },
  {
    path: '/successDetail',
    component: () => import('@/views/login/successDetail')
  },
  {
    path: '/apply',
    component: () => import('@/views/login/apply')
  },
  {
    path: '/SimpleStatistics',
    component: () => import('@/views/SimpleStatistics')
  },
  {
    path: '/InsuranceManagement',
    component: () => import('@/views/InsuranceManagement/insuranceOrders')
  },
  {
    path: '/InsuranceManagementDetail',
    component: () => import('@/views/InsuranceManagement/insuranceOrderDetail')
  },
  {
    path: '/helpManagement',
    component: () => import('@/views/helpManagement')
  },
  {
    path: '/informationManage',
    component: () => import('@/views/informationManage')
  },
  {
    path: '/transferProcess',
    component: () => import('@/views/transferProcess')
  },
  {
    path: '/contact',
    component: () => import('@/views/login/contact')
  },
  {
    path: '/mobileRecorder',
    component: () => import('@/views/mobileRecorder/index')
  },

  {
    path: '/rec',
    component: () => import('@/views/mobileRecorder/Information')
  },
  {
    path: '/recommendation',
    component: () => import('@/views/recommendation')
  },
  {
    path: '/recommendation-rayqee',
    component: () => import('@/views/recommendation-rayqee')
  },
  {
    path: '/layout',
    component: () => import('@/layout/Layout'),
    redirect: '/home',
    children: [
      {
        path: '/home',
        component: () => import('@/views/home/Temp'),
        meta: {
          title: '首页'
        }
      },
      {
        path: '/addTimesheet',
        component: () => import('@/views/salaryCalculation/addTimesheet'),
        meta: {
          title: '工资计算',
          menuId: 66,
          activeMenu: '/salaryCalculationList'
        }
      },

      {
        path: '/addDayTimesheet',
        component: () => import('@/views/salaryCalculation/addDayTimesheet'),
        meta: {
          title: '工资计算',
          menuId: 66,
          activeMenu: '/salaryCalculationList'
        }
      },
      {
        path: '/payingUnit',
        component: () => import('@/views/payingUnit/UnitList'),
        meta: {
          title: '发薪单位维护',
          menuId: 67,
          activeMenu: '/salaryBehalfList'
        }
      },
      {
        path: '/insuredUnit',
        component: () => import('@/views/insuredUnit/UnitList'),
        meta: {
          title: '投保/被投保单位',
          menuId: 1090
        }
      },

      {
        path: '/dividend',
        component: () => import('@/views/dividend/dividend'),
        meta: {
          title: '统计/分润',
        }
      },
      {
        path: '/textMessage',
        component: () => import('@/views/textMessage/textMessage'),
        meta: {
          title: '短信模板',
        }
      },
      {
        path: '/certifiSelection',
        component: () => import('@/views/authentication/certifiSelection'),
        meta: {
          title: '认证中心'
        }
      },
      {
        path: '/certifiForm',
        component: () => import('@/views/authentication/certifiForm'),
        meta: {}
      },
      {
        path: '/personalForm',
        component: () => import('@/views/authentication/personalForm'),
        meta: {}
      },
      {
        path: '/position',
        component: () => import('@/views/position_center/PositionManage'),
        meta: {
          menuId: 89,
          title: '职位管理'
        }
      },
      {
        path: '/category',
        component: () => import('@/views/positionCategory_manage/categoryList'),
        meta: {
          menuId: 90,
          title: '职位类型管理'
        }
      },
      {
        path: '/factoryList',

        component: () => import('@/views/customer_center/CustomerList'),
        meta: {
          title: '企业/客户',
          menuId: 73
        }
      },
      {
        path: '/addDay',

        component: () => import('@/components/addDayTimesheet'),
        meta: {
          title: '新增日结项目',
          menuId: 2239
        }
      },
   
      {
        path: '/BuyCenter',
        component: () => import('@/views/buy/BuyCenter')
      },
      {
        path: '/user',
        meta: {
          activeMenu: '/user',
          menuId: 82,
          title: '管理人员设置'
        },
        component: () => import('@/views/user_center/MyColleague')

        // redirect: "/user/colleague",
        // children: [
        //   {
        //     path: "/user/colleague",
        //     meta: {
        //       activeMenu: "/user",
        //       menuId: 21,
        //       title: "管理人员设置",
        //     },
        //     component: () => import("@/views/user_center/MyColleague"),
        //   },
        // ],
      },
      {
        path: '/role',
        meta: {
          activeMenu: '/role',
          menuId: 81,
          title: '角色及权限管理'
        },
        component: () => import('@/views/role_center/Authority')
      },
      {
        path: '/personalLoans',
        meta: {
          menuId: 2091,
          title: '个人贷款'
        },
        component: () => import('@/views/personalLoans/personalLoansIndex')
      },
      {
        path: '/businessConsulting',

        component: () => import('@/views/businessConsulting/businessConsulting'),
        meta: {
          title: '业务咨询',
          menuId: 2241
        }
      },
      {
        path: '/personalDescriptionPage',
        meta: {
          activeMenu: '/personalLoans',
          menuId: 2091,
          title: '个人贷款'
        },
        component: () => import('@/views/personalLoans/personalDescriptionPage')
      },
      {
        path: '/retirement',
        meta: {
          activeMenu: '/retirement',
          menuId: 2094,
          title: '养老金理财'
        },
        component: () => import('@/views/retirement/retirementIndex')
      },
      {
        path: '/businessAccount',
        meta: {
          activeMenu: '/businessAccount',
          menuId: 2093,
          title: '公户开立'
        },
        component: () => import('@/views/businessAccount/businessAccountIndex')
      },
      {
        path: '/cardDescriptionPage',
        meta: {
          activeMenu: '/cardListIndex',
          menuId: 81,
          title: '用户通知'
        },
        component: () => import('@/views/Card_manage/cardDescriptionPage')
      },
      {
        path: '/businessDescriptionPage',
        meta: {
          activeMenu: '/businessAccount',
          menuId: 81,
          title: '用户通知'
        },
        component: () => import('@/views/businessAccount/businessDescriptionPage')
      },
      {
        path: '/setPayroll',
        component: () => import('@/views/SetPayroll/set'),
        meta: {
          menuId: 2240,
          title: '设置工资条',
        }
      },
      {
        path: '/cardListIndex',
        component: () => import('@/views/Card_manage/index'),
        meta: {
          menuId: 85,
          title: '信用卡'
        }
      },
      {
        path: '/socialSecurity',
        component: () => import('@/views/socialSecurity/index'),
        meta: {
          menuId: 2089,
          title: '社保卡'
        }
      },
      {
        path: '/cardList',
        component: () => import('@/views/Card_manage/CardList'),
        meta: {
          menuId: 85,
          activeMenu: '/cardListIndex'
        }
      },
      {
        path: '/debitCardList',
        component: () => import('@/views/debitCard_manage/index'),
        meta: {
          menuId: 84,
          title: '工资卡'
        }
      },
      {
        path: '/salaryCalculationList',
        component: () => import('@/views/salaryCalculation/salaryCalculationList'),
        meta: {
          menuId: 66,
          title: '工资计算',
          keepAlive: true
        }
      },
      {
        path: '/salaryCalculationDetail',
        component: () => import('@/views/salaryCalculation/salaryCalculationDetail'),
        meta: {
          menuId: 66,
          activeMenu: '/salaryCalculationList'
        }
      },
      {
        path: '/salaryCalculationGenerated',
        component: () => import('@/views/salaryCalculation/salaryCalculationGenerated'),
        meta: {
          menuId: 66,
          activeMenu: '/salaryCalculationList'
        }
      },
      {
        path: '/salaryBehalfList',
        component: () => import('@/views/salaryBehalf/salaryBehalfList'),
        meta: {
          menuId: 67,
          title: '工资直发',
          keepAlive: true
        }
      },
      {
        path: '/salaryBehalfDetail',
        component: () => import('@/views/salaryBehalf/salaryBehalfDetail'),
        meta: {
          menuId: 67,
          activeMenu: '/salaryBehalfList'
        }
      },
      {
        path: '/WeChatBehalf',
        component: () => import('@/views/WeChatBehalf/salaryBehalfList'),
        meta: {
          menuId: 2100,
          title: '微信直发',
          keepAlive: true
        }
      },
      {
        path: '/WeChatBehalfDetail',
        component: () => import('@/views/WeChatBehalf/salaryBehalfDetail'),
        meta: {
          menuId: 2100,
          activeMenu: '/WeChatBehalf'
        }
      },

      {
        path: '/personnelList',
        component: () => import('@/views/talent_center/TalentPool'),
        meta: {
          menuId: 75,
          title: '人员/入职'
        }
      },
      {
        path: '/insuranceList',
        component: () => import('@/views/purchaseInsurance/insuranceList'),
        meta: {
          menuId: 76,
          title: '购买保险'
        }
      },
      {
        path: '/insuranceDescriptionPage',
        component: () => import('@/views/purchaseInsurance/insuranceDescriptionPage'),
        meta: {
          title: '用户须知',
          menuId: 76,
          activeMenu: '/insuranceList'
        }
      },
      {
        path: '/insuranceIntroduction',
        component: () => import('@/views/purchaseInsurance/insuranceIntroduction'),
        meta: {
          menuId: 76,
          activeMenu: '/insuranceList'
        }
      },
      {
        path: '/insuranceOrders',
        component: () => import('@/views/purchaseInsurance/insuranceOrders'),
        meta: {
          menuId: 76,
          title: '保险订单'
        }
      },
      {
        path: '/insuranceOrderDetail',
        component: () => import('@/views/purchaseInsurance/insuranceOrderDetail'),
        meta: {
          menuId: 76,
          title: '保险订单详情',
          activeMenu: '/insuranceOrders'
        }
      },

      {
        path: '/insuranceForm',
        component: () => import('@/views/purchaseInsurance/insuranceForm'),
        meta: {
          menuId: 76
        }
      },

      // {
      //   path: '/set',
      //   component: () => import('@/views/admin/SystemSettings'),
      //   meta: {
      //     title: '系统配置项',
      //     menuId: 70
      //   }
      // },
      {
        path: '/repDistribution',
        component: () => import('@/views/repDistribution/repDistribution'),
        meta: {
          menuId: 2097,
          title: '银行代发',
          activeMenu: '/repDistribution'
          
        }
      },
      {
        path: '/wxrepDistribution',
        component: () => import('@/views/WeChatDistribution/salaryBehalfList'),
        meta: {
          menuId: 2119,
          title: '微信代发',
          keepAlive: true
        }
      },
      {
        path: '/wxrepDistributionDetail',
        component: () => import('@/views/WeChatDistribution/salaryBehalfDetail'),
        meta: {
          menuId: 2119,
          activeMenu: '/wxrepDistribution',
          title: '微信代发',

        }
      },
      {
        path: '/roster',
        component: () => import('@/views/park/roster'),
        meta: {
          menuId: 2102,
          title: '员工花名册',

        }
      },
      {
        path: '/rosterManage',
        component: () => import('@/views/parkmanagement/roster'),
        meta: {
          menuId: 2106,
          title: '员工花名册管理',

        }
      },
      {
        path: '/rosterDetail',
        component: () => import('@/views/park/rosterDetail'),
        meta: {
          menuId: 2102,
          title: '员工花名册详情',
          activeMenu: '/roster'
        }
      },
      {
        path: '/rosterDetailManage',
        component: () => import('@/views/parkmanagement/rosterDetail'),
        meta: {
          menuId: 2106,
          title: '员工花名册详情管理',
          activeMenu: '/rosterManage'
        }
      },
      {
        path: '/reportForms',
        component: () => import('@/views/park/reportForms'),
        meta: {
          menuId: 2103,
          title: '经营季度报表',
        }
      },
      {
        path: '/reportFormsManage',
        component: () => import('@/views/parkmanagement/reportForms'),
        meta: {
          menuId: 2107,
          title: '经营季度报表管理',
        }
      },
      {
        path: '/reportFormsDetail',
        component: () => import('@/views/park/reportFormsDetail'),
        meta: {
          menuId: 2103,
          title: '经营季度报表详情',
          activeMenu: '/reportForms'
        }
      },
      {
        path: '/reportFormsDetailManage',
        component: () => import('@/views/parkmanagement/reportFormsDetail'),
        meta: {
          menuId: 2107,
          title: '经营季度报表详情管理',
          activeMenu: '/reportFormsManage'
        }
      },
      {
        path: '/enterpriseSituation',
        component: () => import('@/views/parkmanagement/enterpriseSituation'),
        meta: {
          menuId: 2108,
          title: '企业情况表',
          activeMenu: '/reportFormsManage'
        }
      },
      {
        path: '/parkUpload',
        component: () => import('@/views/park/parkUpload'),
        meta: {
          menuId: 2103,
          title: '资料上传',
        }
      },
      {
        path: '/businessLoan',
        component: () => import('@/views/businessLoan/businessLoan'),
        meta: {
          menuId: 2099,
          title: '企业贷款',
          activeMenu: '/businessLoan'
        }
      },

      {
        path: '/quick',
        component: () => import('@/views/quick/quick'),
        meta: {
          menuId: 2223,
          title: '快捷处理',

        }
      },
      {
        path: '/demo',
        component: () => import('@/views/demo/demoTabs'),
        redirect: '/demo/demoIndex',
        children: [
          {
            path: '/demo/demoIndex',
            meta: {
              menuId: 39,
              title: 'demo页'
            },
            component: () => import('@/views/demo/demoIndex')
          }

        ]
      },

    ]
  }, {
    path: '/:catchAll(.*)',
    name: 'not-found',
    component: () => import('@/views/404.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach(function (to, from, next) {

  // 判断是否存在token
  if (!localStorage.getItem('Authorization')) {
    // 判断去往的页面是不是登录页
    if (to.path == '/loginform' || to.path == '/success' || to.path == '/successDetail' || to.path == '/apply' || to.path == '/contact' || to.path == '/mobileRecorder' || to.path == '/rec') {
      next()
    } else if (to.path != '/login') {
      next('/login')
    }
  }
  next()
})
router.afterEach((to, from) => {
  if (to.path.indexOf('console') !== -1) {
    window.localStorage.removeItem('Authorization')
  } else {
    window.localStorage.removeItem('admin_Authorization')
  }
})

export default router
